import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { HelperService } from "../shared/helper.service";
import { Observable } from "rxjs";

@Injectable()
export class CeoReportsService {
  baseUrl: string = environment.api_base_url;

  constructor(public http: HttpClient, private helperService: HelperService) {}

  getSoldInventortyReport(params?) {
    let qParams = params ? this.helperService.removeNullQParams(params) : {};
    return this.helperService.get(`ceoReports/reserved_inventory`, qParams);
  }

  getAvaliableInventortyReport(params?) {
    let qParams = params ? this.helperService.removeNullQParams(params) : {};
    return this.helperService.get(`ceoReports/available_inventory`, qParams);
  }

  getNotAvaliableInventortyReport(params?) {
    let qParams = params ? this.helperService.removeNullQParams(params) : {};
    return this.helperService.get(
      `ceoReports/not_available_inventory`,
      qParams
    );
  }

  getDuesInventoryReport(params?) {
    let qParams = params ? this.helperService.removeNullQParams(params) : {};
    return this.helperService.get(`ceoReports/dues_payment`, qParams);
  }

  getDuesPaymentWithSharing(params?): Observable<any> {
    params = this.helperService.removeNullQParams(params);
    return this.helperService.get(`ceoReports/dues-payment-with-sharing`, params);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/ceo-reports/ceo-reports.service.ts